import React, { useEffect, useState } from "react";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import "./css/today.css";

const Today = () => {
  const [orders, setOrders] = useState([]);
  const [pickupOrders, setPickupOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("restaurantOrders");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [todayDate, setTodayDate] = useState(""); // State to store today's date
  const organizationId = JSON.parse(localStorage.getItem("organizationId"));

  // Get today's date in the required format (YYYY-MM-DD)
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        setError(null);

        const date = getTodayDate(); 
        setTodayDate(date); 

        // Fetch all orders for the current date
        const response = await axiosOrganizationInstance.get(`/organization-orders/${organizationId}`, {
          params: { selectedDate: date }, // Pass selectedDate in query params
        });

        if (response.data.status === "success") {
          setOrders(response.data.data.orders || []);
          setPickupOrders(response.data.data.pickup_orders || []);
        } else {
          throw new Error("Failed to fetch orders and pickup orders");
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [organizationId]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="today-container">
      <div className="today-content">
       
        
        

        <div className="tabs">
          <button
            className={`tab-button ${activeTab === "restaurantOrders" ? "active" : ""}`}
            onClick={() => setActiveTab("restaurantOrders")}
          >
             Orders
          </button>
          <button
            className={`tab-button ${activeTab === "pickupOrders" ? "active" : ""}`}
            onClick={() => setActiveTab("pickupOrders")}
          >
            Pickups
          </button>
          <span style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>({todayDate})</span>
        </div>

        {activeTab === "restaurantOrders" && (
          <div className="today-table-container">
            {/* <h4>Restaurant Orders</h4> */}
            {orders.length === 0 ? (
              <p className="nodata">No restaurant orders available for today.</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Child Name</th>
                    <th>Child Details</th>
                    <th>Delivery Contact Name</th>
                    <th>Delivery Contact No</th>
                    <th>Restaurant Name</th>
                    <th>Food Items</th>
                    <th>Food Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order.Order_Id}>
                      <td>{order.Child_Name || "N/A"}</td>
                      <td>{order.Child_Details || "N/A"}</td>
                      <td>{order.Delivery_Contact_Name || "N/A"}</td>
                      <td>{order.Delivery_Contact_No || "N/A"}</td>
                      <td>{order.Restaurant_Name || "N/A"}</td>
                      <td>{order.Food_Items.join(", ") || "N/A"}</td>
                      <td>{order.Food_Quantity || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {activeTab === "pickupOrders" && (
          <div className="today-table-container">
            {/* <h4>Pickup Orders</h4> */}
            {pickupOrders.length === 0 ? (
              <p className="nodata">No pickup orders available for today.</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Child Name</th>
                    <th>Child Details</th>
                    <th>Delivery Contact Name</th>
                    <th>Delivery Contact No</th>
                    <th>Restaurant Name</th>
                    <th>Food Items</th>
                    <th>Food Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {pickupOrders.map((pickup) => (
                    <tr key={pickup.Pickup_Id}>
                      <td>{pickup.Child_Name || "N/A"}</td>
                      <td>{pickup.Child_Details || "N/A"}</td>
                      <td>{pickup.Delivery_Contact_Name || "N/A"}</td>
                      <td>{pickup.Delivery_Contact_No || "N/A"}</td>
                      <td>{pickup.Restaurant_Name || "N/A"}</td>
                      <td>{pickup.Food_Items.join(", ") || "N/A"}</td>
                      <td>{pickup.Food_Quantity || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Today;
